<template>
  <v-card
    elevation="4"
    outlined
  >
    <v-card-subtitle class="pl-2 pb-2 pt-3">
      Lista de itens:
    </v-card-subtitle>

    <v-divider></v-divider>

    <v-row class="d-flex mt-1 px-2">
      <v-col cols="9">
        <v-text-field
          ref="itemInputRef"
          v-model="itemASerAdicionado.nome"
          outlined
          dense
          clearable
          label="Item:"
          counter="30"
          validate-on-blur
          hint="Máximo de 30 caracteres"
          persistent-hint
          :rules="[(v) => v ? v.length <= 30 || 'Máximo de 30 caracteres' : true]"
        >
        </v-text-field>
      </v-col>

      <v-col
        cols="3"
        class="d-flex justify-end"
      >
        <v-btn
          color="primary"
          @click="adicionarItem"
        >
          Adicionar
        </v-btn>
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="opcoesDataLocale"
      hide-default-header
      hide-default-footer
      no-data-text="Nenhum item adicionado"
    >
      <template v-slot:item.actions="{ item, index }">
        <div class="d-flex justify-end">
          <v-icon @click="removerItem(index)">
            {{ icons.mdiDelete }}
          </v-icon>
        </div>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { ref, computed } from '@vue/composition-api'
import { mdiDelete } from '@mdi/js'

export default {
  props: {
    opcoes: {
      type: Array,
      required: true,
    },
  },

  setup(props, { emit }) {
    const headers = [
      { text: 'Nome', value: 'nome' },
      { text: 'Actions', value: 'actions' },
    ]
    const opcoesDataLocale = ref([...props.opcoes])
    const itemInputRef = ref(null)
    const itemASerAdicionado = ref({
      nome: '',
    })
    const nomePossui30CaracteresOuMenos = computed(() => itemASerAdicionado.value.nome.length <= 30)
    const itemJaFoiAdicionado = computed(() => opcoesDataLocale.value
      .find(o => o.nome.toLowerCase() === itemASerAdicionado.value.nome.toLowerCase()))

    const updateOpcoes = () => emit('update:opcoes', opcoesDataLocale.value)
    const adicionarItem = () => {
      if (itemASerAdicionado.value.nome && nomePossui30CaracteresOuMenos.value && !itemJaFoiAdicionado.value) {
        opcoesDataLocale.value.push({ ...itemASerAdicionado.value })
        itemASerAdicionado.value.nome = ''
        updateOpcoes()
      } else {
        itemInputRef.value.focus()
      }
    }
    const removerItem = index => {
      opcoesDataLocale.value.splice(index, 1)
      updateOpcoes()
    }

    return {
      headers,
      opcoesDataLocale,
      itemInputRef,
      itemASerAdicionado,
      adicionarItem,
      removerItem,
      icons: {
        mdiDelete,
      },
    }
  },
}
</script>
